import { z } from "zod/v4";

import {
  ConditionNodeDefinitionSchema,
  ConditionNodeResultSchema,
} from "./condition-node";
import {
  ExportMessageNodeDefinitionSchema,
  ExportMessageNodeResultSchema,
} from "./export-message-node";
import {
  InjectContextNodeDefinitionSchema,
  InjectContextNodeResultSchema,
} from "./inject-context-node";
import {
  LLMChatNodeDefinitionSchema,
  LLMChatNodeResultSchema,
} from "./llm-chat-node";
import {
  LLMFilterNodeDefinitionSchema,
  LLMFilterNodeResultSchema,
} from "./llm-filter-node";
import {
  LLMObjectNodeDefinitionSchema,
  LLMObjectNodeResultSchema,
} from "./llm-object-node";
import { StartNodeDefinitionSchema } from "./start-node";
import {
  ToolExecutionNodeDefinitionSchema,
  ToolExecutionNodeResultSchema,
} from "./tool-execution-node";
import {
  UserInputNodeDefinitionSchema,
  UserInputNodeResultSchema,
} from "./user-input-node";
import {
  VariableNodeDefinitionSchema,
  VariableNodeResultSchema,
} from "./variable-node";

export const NodeDefinitionSchema = z.discriminatedUnion("type", [
  VariableNodeDefinitionSchema,
  LLMChatNodeDefinitionSchema,
  UserInputNodeDefinitionSchema,
  ConditionNodeDefinitionSchema,
  ToolExecutionNodeDefinitionSchema,
  StartNodeDefinitionSchema,
  LLMFilterNodeDefinitionSchema,
  InjectContextNodeDefinitionSchema,
  ExportMessageNodeDefinitionSchema,
  LLMObjectNodeDefinitionSchema,
]);

export const NodeEdgeSchema = z.object({
  id: z.string(),
  source: z.string(), // Node ID
  target: z.string(), // Node ID
  conditionTree: z.any().optional(), // For conditional edges - AiNodeContext is complex
  label: z.string().optional(),
});

export const NodeResultSchema = z.discriminatedUnion("type", [
  VariableNodeResultSchema,
  LLMChatNodeResultSchema,
  UserInputNodeResultSchema,
  ConditionNodeResultSchema,
  ToolExecutionNodeResultSchema,
  LLMFilterNodeResultSchema,
  InjectContextNodeResultSchema,
  ExportMessageNodeResultSchema,
  LLMObjectNodeResultSchema,
]);

// TypeScript types inferred from Zod schemas
export type NodeDefinition = z.infer<typeof NodeDefinitionSchema>;
export type NodeEdge = z.infer<typeof NodeEdgeSchema>;
export type NodeResult = z.infer<typeof NodeResultSchema>;
